// src/components/common/DateRangeFilter.jsx
import React, { useEffect, useRef, useState } from "react";

function toMD(input) {
  if (!input) return "";
  // Prefer YYYY-MM-DD at the beginning of the string
  const m = String(input).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) {
    const month = String(Number(m[2]));
    const day = String(Number(m[3]));
    return `${month}/${day}`;
  }
  // Fallback: try native Date parsing (covers "YYYY-MM-DD HH:mm", etc.)
  const d = new Date(input);
  if (!Number.isNaN(d.getTime())) {
    return `${d.getMonth() + 1}/${d.getDate()}`;
  }
  // Last resort: return raw
  return String(input);
}

export default function DateRangeFilter({
  value = { from: "", to: "" },
  onChange = () => {},
  placeholder = "From-To",        // ✅ shorter, single-line placeholder
}) {
  const [open, setOpen] = useState(false);
  const [from, setFrom] = useState(value.from || "");
  const [to, setTo] = useState(value.to || "");
  const panelRef = useRef(null);

  useEffect(() => {
    setFrom(value.from || "");
    setTo(value.to || "");
  }, [value.from, value.to]);

  useEffect(() => {
    function onDoc(e) {
      if (open && panelRef.current && !panelRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  // ✅ short, no-year label: "8/1-8/7" / "8/1-" / "-8/7"
  const label =
    from || to
      ? `${from ? toMD(from) : ""}${from || to ? "-" : ""}${to ? toMD(to) : ""}`
      : placeholder;

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full border rounded px-2 py-1 text-xs text-left bg-white whitespace-nowrap truncate"
        title={label}
      >
        {label}
      </button>

      {open && (
        <div
          ref={panelRef}
          className="absolute z-[300] left-0 mt-1
                    w-80 sm:w-96 min-w-[20rem] max-w-[calc(100vw-2rem)]
                    rounded-xl border bg-white shadow-lg p-3"
        >
          <div className="text-xs mb-2 font-medium">Date range</div>

          {/* 兩個日期輸入 + 'to'：單列、三欄，不會擠爆 */}
          <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-2">
            <input
              type="date"
              className="w-full border rounded px-2 py-1 text-xs"
              value={from}
              onChange={(e) => setFrom(e.target.value)}
            />
            <span className="text-xs text-gray-500 px-1 whitespace-nowrap">to</span>
            <input
              type="date"
              className="w-full border rounded px-2 py-1 text-xs"
              value={to}
              onChange={(e) => setTo(e.target.value)}
            />
          </div>

          <div className="mt-3 flex justify-end gap-2">
            <button
              type="button"
              className="px-2 py-1 text-xs border rounded"
              onClick={() => {
                setFrom("");
                setTo("");
                onChange({ from: "", to: "" });
                setOpen(false);
              }}
            >
              Clear
            </button>
            <button
              type="button"
              className="px-2 py-1 text-xs rounded bg-blue-600 text-white"
              onClick={() => {
                onChange({ from, to });
                setOpen(false);
              }}
            >
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
